/**
 * Hook to determine if the host is also playing in the game.
 * Prefer the stable room-state flag set by the backend for the current game session.
 * Fall back to player-list inference for older room-state payloads.
 */
export function useHostPlaying(roomState: {
  hostId: string;
  hostIsPlaying?: boolean;
  players: Array<{ id: string; socketId?: string; isHost?: boolean }>;
}): boolean {
  if (!roomState || !roomState.players) {
    return false;
  }
  if (typeof roomState.hostIsPlaying === 'boolean') {
    return roomState.hostIsPlaying;
  }
  return roomState.players.some(
    (p) => p.isHost === true || p.id === roomState.hostId || p.socketId === roomState.hostId
  );
}
